<template>
  <v-app id="inspire" dark>
    <main>
      <v-content>
        <div id="NotFound">
          <h1> Not Found :( </h1>
        </div>
      </v-content>
    </main>
    <v-footer app fixed>
      <span>&copy; 2017</span>
    </v-footer>
  </v-app>

</template>
<script>
export default {
  name: "NotFound",
  data: () => ({

  })
}
</script>
<style l scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/notFound.vue